import type {
  CarouselBiggestType,
  CarouselFavoriteType,
  CarouselRecentlyType,
  CategoryCardType,
} from '@/types'

export const stats: CategoryCardType[] = [
  {
    id: 1,
    imgCard: '/assets/profile/cup.png',
    price: 322,
    priceColor: '#FFFFFF',
    title: 'Rank',
  },
  {
    id: 2,
    imgCard: '/assets/info/wagered.png',
    price: 456200,
    priceColor: '#FFFFFF',
    prefix: '$',
    title: 'Wagered',
  },
  {
    id: 3,
    imgCard: '/assets/info/coin.png',
    price: 456200,
    priceColor: '#FFFFFF',
    prefix: '$',
    title: 'Profit',
  },
  {
    id: 4,
    imgCard: '/assets/info/total.png',
    price: 400,
    priceColor: '#FFFFFF',
    title: 'Bets',
  },
  {
    id: 5,
    imgCard: '/assets/info/win_2.png',
    price: 2400,
    priceColor: '#2CEA65',
    title: 'Wins',
  },
  {
    id: 6,
    imgCard: '/assets/info/lose_2.png',
    price: 206,
    priceColor: '#FF4A53',
    title: 'Loses',
  },
]

export const biggest: CarouselBiggestType[] = [
  {
    id: 1,
    imgCard: '/assets/tops/1.png',
    won: 2000,
    date: 'Jan 23, 2024',
  },
  {
    id: 2,
    imgCard: '/assets/tops/2.png',
    won: 2500,
    date: 'Jan 23, 2024',
  },
  {
    id: 3,
    imgCard: '/assets/tops/3.png',
    won: 2100,
    date: 'Jan 23, 2024',
  },
  {
    id: 4,
    imgCard: '/assets/tops/4.png',
    won: 2000,
    date: 'Jan 23, 2024',
  },
  {
    id: 5,
    imgCard: '/assets/tops/5.png',
    won: 2300,
    date: 'Jan 23, 2024',
  },
  {
    id: 6,
    imgCard: '/assets/tops/6.png',
    won: 3000,
    date: 'Jan 23, 2024',
  },
  {
    id: 7,
    imgCard: '/assets/tops/7.png',
    won: 3500,
    date: 'Jan 23, 2024',
  },
  {
    id: 8,
    imgCard: '/assets/tops/3.png',
    won: 5000,
    date: 'Jan 23, 2024',
  },
  {
    id: 9,
    imgCard: '/assets/tops/4.png',
    won: 7000,
    date: 'Jan 23, 2024',
  },
  {
    id: 10,
    imgCard: '/assets/tops/5.png',
    won: 9000,
    date: 'Jan 23, 2024',
  },
  {
    id: 11,
    imgCard: '/assets/tops/6.png',
    won: 10000,
    date: 'Jan 23, 2024',
  },
]

export const favorites: CarouselFavoriteType[] = [
  {
    id: 1,
    imgCard: '/assets/new-release/1.png',
    time: 45,
    wagered: 5000,
    profit: 4500,
  },
  {
    id: 2,
    imgCard: '/assets/new-release/2.png',
    time: 48,
    wagered: 35000,
    profit: 9500,
  },
  {
    id: 3,
    imgCard: '/assets/new-release/3.png',
    time: 100,
    wagered: 7000,
    profit: 5600,
  },
  {
    id: 4,
    imgCard: '/assets/new-release/4.png',
    time: 20,
    wagered: 2700,
    profit: 500,
  },
  {
    id: 5,
    imgCard: '/assets/new-release/5.png',
    time: 49,
    wagered: 25000,
    profit: 55000,
  },
  {
    id: 6,
    imgCard: '/assets/new-release/6.png',
    time: 10,
    wagered: 1000,
    profit: 6500,
  },
  {
    id: 7,
    imgCard: '/assets/new-release/7.png',
    time: 40,
    wagered: 7000,
    profit: 9500,
  },
  {
    id: 8,
    imgCard: '/assets/tops/3.png',
    time: 48,
    wagered: 3000,
    profit: 1500,
  },
  {
    id: 9,
    imgCard: '/assets/tops/4.png',
    time: 60,
    wagered: 10000,
    profit: 9500,
  },
  {
    id: 10,
    imgCard: '/assets/tops/5.png',
    time: 46,
    wagered: 7000,
    profit: 3500,
  },
  {
    id: 11,
    imgCard: '/assets/tops/6.png',
    time: 20,
    wagered: 1000,
    profit: 5700,
  },
]

export const recently: CarouselRecentlyType[] = [
  {
    id: 1,
    imgCard: '/assets/lives/1.png',
    date: 'Jan 23, 2024',
    wagered: 2000,
    profit: 5500,
  },
  {
    id: 2,
    imgCard: '/assets/lives/2.png',
    date: 'Jan 23, 2024',
    wagered: 2000,
    profit: 5500,
  },
  {
    id: 3,
    imgCard: '/assets/lives/3.png',
    date: 'Jan 23, 2024',
    wagered: 2000,
    profit: 5500,
  },
  {
    id: 4,
    imgCard: '/assets/lives/4.png',
    date: 'Jan 23, 2024',
    wagered: 2000,
    profit: 5500,
  },
  {
    id: 5,
    imgCard: '/assets/lives/5.png',
    date: 'Jan 23, 2024',
    wagered: 2000,
    profit: 5500,
  },
  {
    id: 6,
    imgCard: '/assets/lives/6.png',
    date: 'Jan 23, 2024',
    wagered: 2000,
    profit: 5500,
  },
  {
    id: 7,
    imgCard: '/assets/lives/7.png',
    date: 'Jan 23, 2024',
    wagered: 2000,
    profit: 5500,
  },
  {
    id: 8,
    imgCard: '/assets/tops/3.png',
    date: 'Jan 23, 2024',
    wagered: 2000,
    profit: 5500,
  },
  {
    id: 9,
    imgCard: '/assets/tops/4.png',
    date: 'Jan 23, 2024',
    wagered: 2000,
    profit: 5500,
  },
  {
    id: 10,
    imgCard: '/assets/tops/5.png',
    date: 'Jan 23, 2024',
    wagered: 2000,
    profit: 5500,
  },
  {
    id: 11,
    imgCard: '/assets/tops/6.png',
    date: 'Jan 23, 2024',
    wagered: 2000,
    profit: 5500,
  },
]
